'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UISelectableBox = require('UIComponents/button/UISelectableBox');

var _UISelectableBox2 = _interopRequireDefault(_UISelectableBox);

var _PriceDisplay = require('../common/pricing/PriceDisplay');

var _PriceDisplay2 = _interopRequireDefault(_PriceDisplay);

var _PricingSelectors = require('../../selectors/PricingSelectors');

var _pricingUtils = require('../../utils/pricingUtils');

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanOption = (0, _styledComponents2.default)(_UISelectableBox2.default).withConfig({
  displayName: 'PlanButton__PlanOption'
})(['&&&{border-radius:0;margin:0;flex:1;padding:10px;align-self:stretch;display:flex;justify-content:center;align-items:center;height:92px;width:100%;}']);

var PlanText = _styledComponents2.default.div.withConfig({
  displayName: 'PlanButton__PlanText'
})(['font-size:14px;']);

var Plan = _styledComponents2.default.div.withConfig({
  displayName: 'PlanButton__Plan'
})(['font-weight:600;']);

function PlanButton(_ref) {
  var merchandiseId = _ref.merchandiseId,
      edition = _ref.edition,
      selected = _ref.selected,
      onSelectedChange = _ref.onSelectedChange,
      pricingDependencies = _ref.pricingDependencies;
  var currencyCode = pricingDependencies.currencyCode;

  var price = (0, _pricingUtils.calculatePriceAndItemConfig)(_extends({}, pricingDependencies, {
    merchandiseId: merchandiseId
  })).monthly.calculatedPrice;
  return _react2.default.createElement(
    PlanOption,
    { selected: selected, onSelectedChange: onSelectedChange },
    _react2.default.createElement(
      PlanText,
      null,
      _react2.default.createElement(
        Plan,
        null,
        _react2.default.createElement(_FormattedMessage2.default, {
          message: 'pricingPage.calculator.edition.' + edition
        })
      ),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_PriceDisplay2.default, { price: price, currencyCode: currencyCode }),
        _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.calculator.priceDisplay.perMonthFull' })
      )
    )
  );
}

var mapStateToProps = function mapStateToProps(state) {
  return {
    pricingDependencies: (0, _PricingSelectors.pricingDependenciesSelector)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(PlanButton);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/PlanButton.js
// module id = 330
// module chunks = 3 4